import ZTag from './ZTag.vue'

export default ZTag
